import React from 'react';

const Maps = ({ card }) => {
  return (
    <div className="map z-index-none">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d58469.54268035655!2d-46.80613678375898!3d-23.66356653919901!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce4fd72cceb9af%3A0xbdd8cbe3166ea74!2sComercial%20Ficael!5e0!3m2!1spt-BR!2sbr!4v1734818026895!5m2!1spt-BR!2sbr"
            style={{
              border: "0",
              marginBottom: "-7px",
              width: "100%",
              height: "400px",
            }}
            loading="lazy"
          ></iframe>
        </div>
  );
};

export default Maps;
